import React from "react";
import { Seo } from "@/lib/seo";
import { PageHero } from "@/components/layout/PageHero";
import { Blocks } from "@/components/sections/Blocks";
import { PlatformCta } from "@/components/sections/PlatformCta";
import { useLang } from "@/i18n/LanguageContext";
import { deepLocalize } from "@/i18n/translate";

export default function InstitutionalPage({ config: rawConfig }) {
  const { lang } = useLang();
  const config = deepLocalize(rawConfig, lang);
  // Collect FAQ blocks for FAQ schema
  const faq = (config.blocks || []).filter((b) => b.type === "accordion").flatMap((b) => b.items || []);
  return (
    <>
      <Seo
        title={config.seoTitle}
        description={config.seoDescription}
        path={config.path}
        breadcrumbs={config.breadcrumbs}
        faq={faq.length ? faq : undefined}
      />
      <PageHero
        overline={config.overline}
        title={config.title}
        subtitle={config.subtitle}
        breadcrumbs={config.breadcrumbs}
      />
      <Blocks blocks={config.blocks} />
      {config.cta && <PlatformCta />}
    </>
  );
}
